import { useState, useEffect } from 'react';
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@mui/material';

export default function InstallPrompt({ open, onClose }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /Android/.test(navigator.userAgent);

  useEffect(() => {
    // Проверяем, запущено ли приложение в standalone-режиме
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isStandalone) {
      setIsInstalled(true);
    }

    const handler = (e) => {
      e.preventDefault(); // Логируем событие
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, [deferredPrompt]);

  const handleInstall = async () => {
    if (deferredPrompt) {
      try {
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
          setIsInstalled(true);
        }
        setDeferredPrompt(null);
      } catch (error) {
        console.error('Илова отказишда хатолик юз берди:', error);
      }
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Иловани ўрнатиш</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isInstalled
            ? 'Илова аллақачон ўрнатилган! Бош экрандаги икона орқали очинг.'
            : isIOS
            ? 'Safari браузерида "Поделиться" тугмасини босинг ва "Добавить на экран Домой" ни танланг.'
            : isAndroid
            ? 'Иловага тез кириш учун бош экранга ўтказинг! "Ўтказиш" тугмасини босинг.'
            : 'Иловага тез кириш учун бош экранга ўтказинг!'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Кейинроқ</Button>
        {!isIOS && !isInstalled && (
          <Button
            onClick={handleInstall}
            color="primary"
            variant="contained"
            disabled={!deferredPrompt}
          >
            Ўтказиш
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}